import React from 'react';
import { DashboardAdminTranslation } from '../../constants';
import { DashboardSearchData } from '../types-store';
import { ListItem } from './list-item';

import styles from './list-results.scss';

interface ListResultsProps {
  listItems: DashboardSearchData[];
  deletingDashboards: number[];
  deleteDashboard: (id: number, successMessage: string) => void;
  translation: DashboardAdminTranslation;
}

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, deletingDashboards, deleteDashboard, translation
}) => {

  return listItems && listItems.length > 0
    ? <div className={styles.listItems}>
      {listItems.map((listItem) => {
        return <ListItem
          key={listItem.code.value}
          item={listItem}
          deleting={deletingDashboards?.includes(listItem.code.value) ?? false}
          deleteDashboard={deleteDashboard}
          translation={translation}
        />;
      })}
    </div>
    : null;
};
